<div class="aaa">
  <div class="box-login" [formGroup]="formGroup">
    <h1>LOGIN</h1>

    <input placeholder="E-mail" type="email" formControlName="email" />
    <input placeholder="Senha" type="password" formControlName="password" />

    <p-button
      (click)="submit()"
      [disabled]="isLoading"
      [label]="isLoading ? 'Carregando' : 'Entrar'"
      severity="contrast"
    />
  </div>
</div>
